export const section1 = {
    "en" : {
    title: "Built For Efficiency",
    subtitle: "Get a glimpse of the two sides of Melior; The App for your patients and The Dashboard for you"
},
    "ar" : {
    title: "مصمم لضمان أعلى فاعلية",
    subtitle: "من خلال تطبيق مخصص للمريض ولوحة تحكم ومعلومات مخصصة  لفريق تحسين الجودة"
}

}

export const section2 = {
    "en" : {
    title: "Listen to your patients’ feedback",
    text: "The Melior App is downloadable on any android device. Through an easy 30 seconds survey, your patients can review the service they received and send their complaints, if they have any!",
    img: "mobile.png",
    list: [
        {
            icon: "",
            text: "Questions designed by healthcare experts to guarantee constructive feedback"
        }
        ,
        {
            icon: "",
            text: "Patients can submit their feedback through survey links sent in SMS or email"
        }
        ,
        {
            icon: "",
            text: "Your patients can choose between arabic and english surveys"
        }
        ,
        {
            icon: "",
            text: "Patients can record or type out their complaints easily"
        }
    ]
},
    "ar" : {
    title: "استمع إلى ملاحظات مرضاك",
    text: "يمكن تنزيل تطبيق Melior على أي جهاز يعمل بنظام Android. من خلال استبيان سهل مدته 30 ثانية ، يمكن لمرضاك مراجعة الخدمة التي تلقوها وإرسال شكاواهم ، إذا كان لديهم أي منها!",
    img: "mobile.png",
    list: [
        {
            icon: "",
            text: "أسئلة مصممة من قبل خبراء الرعاية الصحية لضمان ملاحظات بناءة"
        }
        ,
        {
            icon: "",
            text: "يمكن للمرضى إرسال ملاحظاتهم من خلال روابط الاستبيان المرسلة عبر الرسائل القصيرة أو البريد الإلكتروني"
        }
        ,
        {
            icon: "",
            text: "يمكن لمرضاك الاختيار بين استطلاعات الرأي باللغتين العربية والإنجليزية"
        }
        ,
        {
            icon: "",
            text: "تتيح واجهة المريض التسجيل الصوتي أو الكتابي للشكاوى بسهولة"
        }
    ]
}
}

export const section3 = {
    "en" : {
    title: "Visualize your performance through in-depth analysis of the responses you receive",
    text: "All data collected feeds into a personal dashboard where you can view and analyze your patients' responses",
    img: "desktop.png",
    list: [
        {
            icon: "liPress",
            text: "Real-time analysis of responses"
        }
        ,
        {
            icon: "liPie",
            text: "Dynamic graphs to analyze and compare"
        }
        ,
        {
            icon: "",
            text: "Filter the data by date, branches and departments"
        }
        ,
        {
            icon: "",
            text: "Get notified with new responses"
        }
    ]
},
    "ar" :  {
    title: "تابع أداء فريقك بشكل مرئي من خلال تحليل البيانات الناتجة عن تفاعل المرضى مع الخدمة",
    text: "جميع آراء ومشاركات المرضى يتم تجميعها في لوحة معلومات ذكية تسمح لك",
    img: "desktop.png",
    list: [
        {
            icon: "liPress",
            text: "تجميع وتحليل آراء المرضى بشكل لحظي"
        }
        ,
        {
            icon: "liPie",
            text: "رسوم بيانية تفاعلية توضح أهم المشاكل وتقارن أداء فريقك بين الفترات الزمنية المختلفة"
        }
        ,
        {
            icon: "",
            text: "عرض البيانات الخاصة بكل قسم أو فرع أو عيادة على فترات زمنية مختلفة من إختيارك"
        }
        ,
        {
            icon: "",
            text: "من خلال الإخطارات الفورية عند تلقي رأى المريض يمكنك متابعة آراء المرضى على مدار الساعة "
        }
    ]
}
}

export const section4 = {
    "en" : {
    title: "Monitor every response you get from your patients, take actions and improve their experience",
    text: "",
    img: "product.png",
    list: [
        {
            icon: "",
            text: "View every complain and review"
        }
        ,
        {
            icon: "hand",
            text: "Add notes, assign, and resolve complaints"
        }
        ,
        {
            icon: "liStar",
            text: "Star important responses"
        }
        ,
        {
            icon: "hand",
            text: "Filter data by date, branch and department"
        }
    ]
},
    "ar" : {
    title: "حسن أدائك بشكل مستمر ومرن من خلال الإستجابة لتطلعات واحتياجات المرضى",
    text: "",
    img: "product_ar.png",
    list: [
        {
            icon: "",
            text: "يمكنك الإطلاع على آراء المرضى بشكل مجمع ومحلل وبشكل فردي يسمح لك بالتعامل مع كل رأي على حدى"
        }
        ,
        {
            icon: "hand",
            text: "يمكن لفريقك التواصل حول الشكاوى المختلفة من خلال إضافة ملاحظات لكل شكوى أو تقييم من تقييمات المرضى "
        }
        ,
        {
            icon: "liStar",
            text: "تمييز الردود المهمة بعلامة"
        }
        ,
        {
            icon: "hand",
            text: "تصفية البيانات حسب التاريخ والفرع والقسم"
        }
    ]
}
}

export const PricingCard = {
    "en" : {
    title: "See pricing",
    subtitle: "Choose a plan that fits your needs",
    button: "See Pricing",
    img: "hand.png"
}, 
    "ar" : {
    title: "انظر الأسعار",
    subtitle: "اختر خطة تناسب احتياجاتك",
    button: "انظر الأسعار",
    img: "hand.png"
}
}